import styled from 'styled-components';

const ButtonStyle = styled.div`
	--btnPadTB: var(--sp2x);
	--btnPadLR: var(--sp3x);
	--btnBorderRadius: var(--sp5x);

	&.btn {
		width: fit-content;
		overflow: hidden;
		cursor: pointer;

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: var(--btnPadTB) var(--btnPadLR);
			color: var(--textPrimaryColor);
			font-size: var(--p4);
			font-family: var(--montserrat_arm);
			font-weight: 500;
			background-color: var(--backgroundPrimaryColor);
			border-radius: var(--btnBorderRadius);
			border: 1px solid var(--borderPrimaryColor);
			transition: color var(--trTime) ease-out, background-color var(--trTime) ease-out;
			cursor: pointer;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						color: var(--backgroundPrimaryColor);
						background-color: var(--textPrimaryColor);
					}
				}
			}
		}

		&.disabled {
			pointer-events: none;

			a,
			button {
				opacity: 0.5;
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--btnBorderRadius: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--btnPadTB: var(--sp1-5x);
		--btnPadLR: var(--sp2-5x);
		--btnBorderRadius: var(--sp5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--btnPadLR: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--btnPadTB: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--btnPadTB: var(--sp1-5x);
		--btnPadLR: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
